module.exports = __webpack_public_path__ + "img/illustrations/csv-invite-modal-c55cacc961a8afe00574556242340c7d.svg";